import { createFileRoute } from "@tanstack/react-router";
import SegmentLanding from "@/pages/SegmentLanding";
import { segmentPages } from "@/config/segmentPages";

const config = segmentPages.find((page) => page.path === "kreditkarte-fuer-studenten")!;

export const Route = createFileRoute("/kreditkarte-fuer-studenten")({
  head: () => ({
    meta: [
      { title: config.seoTitle },
      { name: "description", content: config.seoDescription },
      { property: "og:title", content: config.seoTitle },
      { property: "og:description", content: config.seoDescription },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://www.kreditkarten.de/kreditkarte-fuer-studenten" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [
      { rel: "canonical", href: "https://www.kreditkarten.de/kreditkarte-fuer-studenten" },
    ],
  }),
  component: () => <SegmentLanding config={config} />,
});
